import { pct } from '@shared/format';
import { t } from '../i18n/ru';
import { tierOf } from '../lib/fx';
import { useController } from '../state/context';
import { Bomb } from './Icons';

/** Порог, после которого шкала «тревожная»: пульс, красный жар на фоне. */
export const DANGER_HEAT = 0.75;

export function BombMeter() {
  const c = useController();
  const game = c.game.value;
  const heat = Math.min(1, game?.heat ?? 0);
  const exploded = game?.status === 'lose';
  const filled = game?.boom === 'picked' ? 100 : heat * 100;
  const float = c.fx.value.float;
  const tier = exploded ? 0 : tierOf(heat);
  const label = exploded ? '💥' : pct(game?.heat ?? 0);
  const cls = ['meter-card', !exploded && heat >= DANGER_HEAT ? 'danger' : heat >= 0.25 ? 'warm' : '']
    .filter(Boolean)
    .join(' ');
  return (
    <div class={cls} style={{ '--heat': heat }}>
      <div class="mc-top">
        <span class="mc-label">
          <Bomb class="mc-bomb" />
          {t.bomb}
        </span>
        <span class="val" id="meterVal">
          <span class={heat > 0 ? 'num bump' : 'num'} key={label} data-testid="meter-value">
            {label}
          </span>
          {float && (
            <span class="float" key={float.id} data-testid="meter-float">
              {float.text}
            </span>
          )}
        </span>
      </div>
      <div
        class="fuse"
        role="progressbar"
        aria-label="Нагрев бомбы"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(heat * 100)}
      >
        <div class="fuse-fill" style={{ '--rest': `${100 - filled}%` }} />
        <i class="fuse-tick" style={{ left: '25%' }} />
        <i class="fuse-tick" style={{ left: '50%' }} />
        <i class={exploded ? 'fuse-spark off' : 'fuse-spark'} style={{ left: `${filled}%` }} />
      </div>
      <div class="tiers" aria-hidden="true">
        {[3, 2, 1].map((n) => (
          <span class={n === tier ? 'tier on' : n > tier ? 'tier lost' : 'tier'} key={n}>
            {'★'.repeat(n)}
          </span>
        ))}
      </div>
    </div>
  );
}
